import type { HapticType, PlatformService, SafeAreaInsets } from './types'

const readCssInset = (name: string): number => {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return parseInt(v) || 0
}

export class WebPlatform implements PlatformService {
  readonly mode = 'web' as const

  isTelegram() { return false }
  isWeb() { return true }

  async ready() { /* no-op */ }

  goBack() {
    window.history.back()
  }

  openLink(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  // В вебе Telegram-ссылка — обычная t.me: откроется приложение или веб-клиент.
  openTelegramLink(url: string) {
    this.openLink(url)
  }

  haptic(_type: HapticType) { /* no-op */ }

  close() {
    window.location.href = '/'
  }

  getStartParam(): string | undefined {
    const param = new URLSearchParams(window.location.search).get('start_param')
    return param ?? undefined
  }

  getInitData() { return undefined }

  expand() { /* no-op */ }
  isExpanded() { return true }
  requestFullscreen() { return false }
  disableVerticalSwipes() { /* no-op */ }
  enableVerticalSwipes() { /* no-op */ }

  setHeaderColor(_color: string) { /* no-op */ }
  setBottomBarColor(_color: string) { /* no-op */ }
  setBackgroundColor(_color: string) { /* no-op */ }

  showBackButton(_onClick: () => void) { /* no-op — кнопку рисуем в Header */ }
  hideBackButton() { /* no-op */ }
  showMainButton(_text: string, _onClick: () => void) { /* no-op */ }
  hideMainButton() { /* no-op */ }

  getSafeAreaInsets(): SafeAreaInsets {
    return {
      top: readCssInset('--safe-area-inset-top'),
      bottom: readCssInset('--safe-area-inset-bottom'),
      left: readCssInset('--safe-area-inset-left'),
      right: readCssInset('--safe-area-inset-right')
    }
  }

  applySafeAreaInsetsCssVars() {
    const root = document.documentElement
    // В браузере используем браузерные env() значения, но сохраняем старые имена
    // для совместимости со старой вёрсткой — ставим 0.
    const zero = '0px'
    root.style.setProperty('--tg-viewport-safe-area-inset-top', zero)
    root.style.setProperty('--tg-viewport-safe-area-inset-bottom', zero)
    root.style.setProperty('--tg-viewport-safe-area-inset-left', zero)
    root.style.setProperty('--tg-viewport-safe-area-inset-right', zero)
    root.style.setProperty('--tg-content-safe-area-inset-top', zero)
    root.style.setProperty('--tg-content-safe-area-inset-bottom', zero)
    root.style.setProperty('--tg-content-safe-area-inset-left', zero)
    root.style.setProperty('--tg-content-safe-area-inset-right', zero)
  }

  onViewportChanged(_cb: () => void) {
    return () => {}
  }

  getTelegramUser() { return null }
}
